const sidebarToggles = document.querySelectorAll(".mobile-sidebar-title");
const dropdownMenu = document.querySelector(".mobile-categories-list");
const isActiveCategory = document.querySelectorAll(".mobile-categories-item");

function toggleDropdownIcons(toggle) {
  const downIcon = toggle.querySelector(".down-icon");
  const aboveIcon = toggle.querySelector(".above-icon");

  if (downIcon && aboveIcon) {
    downIcon.classList.toggle("hidden");
    aboveIcon.classList.toggle("hidden");
  }
}

sidebarToggles.forEach((sidebarToggle) => {
  sidebarToggle.addEventListener("click", (e) => {
    e.stopPropagation();

    dropdownMenu.classList.toggle("hidden");

    toggleDropdownIcons(sidebarToggle);

    sidebarToggles.forEach((toggle) => {
      if (toggle !== sidebarToggle) {
        toggle.classList.remove("active");
        toggle.querySelector(".down-icon").classList.remove("hidden");
        toggle.querySelector(".above-icon").classList.add("hidden");
      }
    });

    sidebarToggle.classList.toggle("active");
  });
});

document.addEventListener("click", () => {
  if (!dropdownMenu.classList.contains("hidden")) {
    dropdownMenu.classList.add("hidden");
    sidebarToggles.forEach((toggle) => {
      toggle.classList.remove("active");
      toggle.querySelector(".down-icon").classList.remove("hidden");
      toggle.querySelector(".above-icon").classList.add("hidden");
    });
  }
});

isActiveCategory.forEach(item => {
  item.addEventListener("click", function () {
    const link = item.querySelector("a");
    if (link) {
      window.location.href = link.href;
    }
  });
});
